import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { roadmapList } from "Utils/Helpers/TableColumns";

export default function TableRoadmapData({ data }) {
  return <DataGridComponent data={data} columns={roadmapList} />;
}
